import { useContext, useEffect } from "react";
import { AppContext } from "../../../../AppProvider";
import { usersMicroserviceUrl } from "../../../../../microservices/users_microservice";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/DisablingCustomerUser.css";

const DisablingCustomerUser = ({customerUserStatusUpdate,setCustomerUserStatusUpdate,customerUser}) => {
    const {user} = useContext(AppContext);
    const disableCustomerUser = async () => {
        try{
            const url = `${usersMicroserviceUrl}/tenants/customer-users/${customerUser?.id}/status`;
            const response = await fetch(url, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.access_token}`,
                },
                body: JSON.stringify({ status: 'INACTIVE' }),
            });
            if (response.ok) {
                setCustomerUserStatusUpdate('disabled');
            } else {
                console.error('Failed to disable customer user:', response.statusText);
            }
        }
        catch(error){
            console.error('Unexpected error disabling customer user:', error);
        }
    };
    useEffect(() => {
        if(customerUserStatusUpdate === 'disabling'){
            disableCustomerUser();
        }
    }, [customerUserStatusUpdate]);
    return (
        <div>
            {
                customerUserStatusUpdate === 'disabling' ? 
                (
                    <div className="tenant-administrator-disabling-customer-user-container">
                        <div className="tenant-administrator-disabling-customer-user-loading-message">
                            <div className="tenant-administrator-disabling-customer-user-loading-spinner"></div>
                            <p>Disabling customer user. Please wait</p>
                        </div>
                    </div>
                ):
                customerUserStatusUpdate === 'disabled' ? (
                    <div className="tenant-administrator-disabling-customer-user-container">
                        <div className="tenant-administrator-disabling-customer-user-success-message">
                            <p>Customer user has been disabled successfully</p>
                            <div className="tenant-administrator-disabling-customer-user-success-button-container">
                                <button onClick={() => setCustomerUserStatusUpdate('updated')}>Okay</button>
                            </div>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-disabling-customer-user-container">
                        <div className="tenant-administrator-disabling-customer-user-error-message">
                            <p>An error occurred while disabling customer user</p>
                            <div className="tenant-administrator-disabling-customer-user-error-button-container">
                                <button onClick={() => setCustomerUserStatusUpdate('updated')}>Okay</button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
}
export default DisablingCustomerUser;